import type { DeepString } from "@/lib/i18n";

export const pl = {
  emptyData: "Brak danych do wyświetlenia.",
  emptyList: "Brak usług do wyświetlenia.",
  readMore: "Zobacz usługę",
  inPreparationBadge: "W przygotowaniu",
} as const;

export type CServicesTranslations = DeepString<typeof pl>;
